import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '~/lib/client'

import { handleApiError } from '~/utils/response'
import { handleResponse } from '~/utils/response'

import { taskKeys } from './keys'
import { GetTasksResponse } from '../types'

export const tasksQueryOptions = () => {
    return queryOptions({
        queryKey: taskKeys.tasks(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/users/tasks`);

                const result = await handleResponse<GetTasksResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  console.log("tasksQueryOptions", result.data);
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};




